import { ChangeEvent } from 'react'

import { Box, Switch } from '@material-ui/core'
import { Info } from '@scoir/tooltips'
import { useDispatch, useSelector } from 'react-redux'

import api from 'common/api'
import { actions, selectHasDynamicContent, selectScid } from 'store/college'
import { actions as snactions } from 'store/snackbar'

const PublishedStateToggle = () => {
  const scid = useSelector(selectScid)
  const isPublished = useSelector(selectHasDynamicContent)
  const dispatch = useDispatch()
  const onToggle = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    dispatch(
      actions.updateCollege({
        HasDynamicContent: isChecked,
      }),
    )
    api.post(`/api/colleges/${scid}/content/published`, isChecked).catch(() => {
      dispatch(snactions.addSnackbarItem('An error occurred updating the published state of your content'))
      dispatch(
        actions.updateCollege({
          HasDynamicContent: isPublished || false,
        }),
      )
    })
  }
  return (
    <Box
      display="flex"
      alignItems="center"
    >
      <Switch
        inputProps={{ 'aria-label': 'Publish all content' }}
        checked={isPublished}
        onChange={onToggle}
        color="primary"
      />
      Publish all content
      <Box mx={1}>
        <Info
          outlinedIcon
          inheritColor
          aria-label={'Publish all content'}
        >
          <div className="published-state-toggle-bubble-content">
            <p>
              <strong>Publish all content</strong>
            </p>
            <p>Enabling this will make all saved content visible on your school profile page.</p>
            <p>Hidden content will not show to any users, even when content is set to active.</p>
            <p>Disabling this will hide all saved content from your school profile page.</p>
          </div>
        </Info>
      </Box>
    </Box>
  )
}

export default PublishedStateToggle
